import * as S from './styles';

import Switch from '@components/Common/Switch';
import LabelIcon from '@svgIcons/label.svg';

import PanelOptionMixin from '../mixin';

import { CHART_TYPES } from '@/utils/consts';

const { BAR, HORIZONTAL_BAR, LINE, COMBO_CHART, PIE, DONUT } = CHART_TYPES;

const LABEL_GRAPHS = [BAR, HORIZONTAL_BAR, LINE, COMBO_CHART, PIE, DONUT];

export default {
    name: 'GraphLabelToggleOption',
    mixins: [PanelOptionMixin],
    props: {
        showGraphLabel: { type: Boolean, default: false },
    },
    computed: {
        hasLabelOption: R.compose(
            R.includes(R.__, LABEL_GRAPHS),
            R.pathOr('', ['graphOptions', 'selectedGraphType'])
        ),
    },
    render() {
        const { hasLabelOption, showGraphLabel } = this;

        return (
            hasLabelOption && (
                <S.ComponentWrapper>
                    <div class="top-wrapper">
                        <div class="title">
                            <LabelIcon />
                            <h1>
                                {this.$t(
                                    'NEW_DASHBOARD.graph_label_toggle_option_title'
                                )}
                            </h1>
                        </div>
                        <Switch
                            value={showGraphLabel}
                            type="big"
                            onClick={() => {
                                this.$emit('update', !showGraphLabel);
                            }}
                        />
                    </div>
                </S.ComponentWrapper>
            )
        );
    },
};
